import type { Comando } from "@/components/ui/command-palette/data/comandos";
import { cn } from "@/lib/cn";

/**
 * Fila individual de resultados · resalta cuando es la activa (selección
 * por flechas o hover — el hover también mueve el índice activo para que
 * teclado y mouse queden sincronizados).
 *
 * El original pintaba el activo con `var(--mantine-color-multiva-0)`, un
 * tinte sólido que `AGENTS.md` pide evitar (se ve "lavado" en dark) — acá
 * se corrige a `bg-muted`, consistente con el resto de la migración
 * (`DropdownMenuItem`, etc.).
 */
export function CommandPaletteItem({
  comando,
  activo,
  onHover,
  onClick,
}: {
  comando: Comando;
  activo: boolean;
  onHover: () => void;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={onHover}
      className={cn("w-full px-4 py-2.5 text-left transition-colors", activo ? "bg-muted" : "bg-transparent")}
    >
      <p className="text-sm font-medium text-foreground">{comando.label}</p>
      {comando.descripcion && <p className="mt-0.5 text-xs text-muted-foreground">{comando.descripcion}</p>}
    </button>
  );
}
